import { render } from "./infoIcon.vue?vue&type=template&id=36aa9ad9"
import script from "./infoIcon.vue?vue&type=script&lang=js"
export * from "./infoIcon.vue?vue&type=script&lang=js"

import "./infoIcon.vue?vue&type=style&index=0&id=36aa9ad9&lang=scss"

import exportComponent from "/codebuild/output/src2682924403/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__